import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllRequesters = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/requesters',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveRequester = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/requesters',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateRequester = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/requesters/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteRequester = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/requesters/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllRequesters,
  saveRequester,
  deleteRequester,
  updateRequester,
}
